<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2 class="text-primary" style="margin-bottom: 0px;">
          <i class="fas fa-file-invoice" />
          <span v-if="isSingle">
            <span v-if="form.finalidade_nfe.value">
              {{ finalidade_nfe_options[form.finalidade_nfe.value - 1].text }}
            </span>
            <span v-if="!form.finalidade_nfe.value"> NF-e Avulsa </span>
          </span>
          <span v-if="!isSingle">
            {{ title }}
          </span>
        </h2>
        <small class="text-muted">Emissão de Notas Fiscais.</small>
      </div>
    </div>

    <hr />

    <br />

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12 mb-md-0 mb-4">
            <h5 class="text-primary d-inline">
              <i class="fas fa-file-invoice" /> Dados Da NF-e
            </h5>

            <div class="row" style="padding-top:5px">
              <div class="col-md-2">
                <select-input alias="Série" :options="form.serie.options" v-model="form.serie.value" />
              </div>
              <div class="col-md-2">
                <text-input v-model="form.number.value" alias="Número" />
              </div>
              <template v-if="isSingle">
                <div class="col-md-3">
                  <label for="finalidade_nfe">Finalidade </label>
                  <b-form-select id="finalidade_nfe" size="sm" :disabled="form.model.value != 55"
                    v-model="form.finalidade_nfe.value" :options="finalidade_nfe_options" />
                </div>
                <div class="col-md-3">
                  <label for="tpNF">Tipo de Operação </label>
                  <b-form-select id="tpNF" size="sm" v-model="form.type_nfe.value" :options="operation_options" />
                </div>
              </template>
              <div class="col px-0 mt-3">
                <div class="form-group d-flex flex-column">
                  <b-form-checkbox switch size="sm" v-model="form.presence_indicator.value" inline :value="1"
                    :unchecked-value="0">
                    Venda Presencial
                  </b-form-checkbox>
                  <b-form-checkbox switch size="sm" v-if="showSwitchNfeReference" v-model="showChaveNfeReferenciada"
                    inline>
                    Referenciar NF-e
                  </b-form-checkbox>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6" v-if="isDevolution || showChave">
                <label for="chave_nfe_referenciada">
                  Nota Fiscal Referenciada
                </label>
                <b-form-input id="chave_nfe_referenciada" size="sm" v-model="form.chave_nfe_referenciada.value"
                  placeholder="Digite a chave da nota" />
              </div>
              <div v-if="isSingle" class="col-md-6">
                <label for="operation"> Natureza da Operação </label>
                <b-form-input id="operation" size="sm" v-model="form.operation.value"
                  placeholder="Ex: Venda de Mercadorias" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-2">
                <text-input v-model="form.dhSaiEnt.value" type="datetime-local" id="dhSaiEnt" size="sm"
                  alias="Data e Hora de Saída/Entrada" />
              </div>
              <div class="col-md-3 mt-2" v-if="form.model.value == 55">
                <mask-input v-model="form.autXml_cnpj.value" id="autXml_cnpj" size="sm" :mask="'cnpj'"
                  alias="CNPJ Autorizado a acessar o XML" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <!-- cliente -->
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4 mb-md-0 mb-4">
            <h5 class="text-primary d-inline">
              <i class="fas fa-user" /> {{ isDevolucaoCompraMercadoria ? 'Fornecedor' : 'Cliente' }}
            </h5>

            <div v-if="isDevolution && isDevolucaoCompraMercadoria">
              <VendorSearch v-model="form.client_id.value" />
            </div>
            <div v-else>
              <client-search v-model="form.client_id.value" :name="form.name.value" />
              <client-stats :client_id="form.client_id.value" />
            </div>
          </div>
          <div class="offset-md-2 col-md-4">
            <h5 class="text-primary d-inline">
              <i class="fas fa-user-tie" /> Vendedor
            </h5>
            <salesman-search v-model="form.salesman_id.value" :name="form.salesman_name.value" />
          </div>
        </div>
      </div>
    </div>
    <!-- cliente -->

    <br />
    <br />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <template>
              <order-products ref="orderProducts" v-model="products" :isNfe="true" />
            </template>
            <br />
            <br />
            <div>
              <nfe-product-grid :products="products" @editProduct="setProductUpdate($event)"
                @deleteProduct="deleteProduct($event)" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <br />

    <div class="row">
      <div class="col-md-6 order-2 order-md-1 mb-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <h5 class="text-primary">
                  <i class="fas fa-cash-register" /> Pagamento
                </h5>
              </div>
            </div>
            <br />

            <div class="row">
              <div class="col-md-12 mb-5">
                <order-payments v-model="payments" :orderTotal="orderTotal" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 order-1 order-md-2 mb-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <h5 class="text-primary">
                  <i class="fas fa-equals" /> Totais
                </h5>
              </div>
            </div>

            <div class="row">
              <div class="col-7">
                <span>Total dos Produtos:</span>
              </div>
              <div class="col-5 text-right">
                <span style="padding-right:0.5rem">{{ productsTotal | decimal }}</span>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-5">
                <span>Acrescimo</span>
              </div>

              <div class="col-6 col-md-3 text-right">
                <number-input @keyup="calcUpdateValue('addition')" v-model="additionPercent"
                  :currencySymbol="' %'"></number-input>
              </div>
              <div class="col-6 col-md-4 text-right">
                <number-input @keyup="calcUpdatePercent('addition')" v-model="form.addition.value"></number-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-5">
                <span>Desconto</span>
              </div>

              <div class="col-6 col-md-3 text-right">
                <number-input @keyup="calcUpdateValue('discount')" v-model="discountPercent"
                  :currencySymbol="' %'"></number-input>
              </div>
              <div class="col-6 col-md-4 text-right">
                <number-input @keyup="calcUpdatePercent('discount')" v-model="form.discount.value"></number-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-5">
                <span>Frete</span>
              </div>

              <div class="col-6 col-md-3 text-right">
                <number-input @keyup="calcUpdateValue('shipping')" v-model="shippingPercent"
                  :currencySymbol="' %'"></number-input>
              </div>
              <div class="col-6 col-md-4 text-right">
                <number-input @keyup="calcUpdatePercent('shipping')" v-model="form.shipping.value"></number-input>
              </div>
            </div>

            <div class="row">
              <div class="col-7">
                <span>Total da Venda</span>
              </div>
              <div class="col-5 text-right">
                <b class="text-primary" style="padding-right:0.5rem">{{ orderTotal | decimal }}</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <InvoiceTotals :invoice="form" :products="products" :orderTotal="orderTotal" />

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12 mb-md-0 mb-4">
            <h5 class="text-primary d-inline">
              <i class="fas fa-shipping-fast" /> Frete
            </h5>
            <div>
              <nfe-shipping :form="form" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12 mb-md-0 mb-4">
            <h5 class="text-primary d-inline">
              <i class="fas fa-exclamation-circle"></i> Informações Adicionais
            </h5>
            <div style="padding-top:10px">
              <nfe-observations :form="form" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <br />

    <error-handler :error="error" />

    <b-alert :show="alertData.isVisible" fade variant="danger" @dismissed="alertData.isVisible = false" dismissible>{{
      alertData.message }}</b-alert>

    <div class="row">
      <div class="col-md-12 text-right">
        <router-link to="/vendas">
          <button role="button" class="mb-2 bl-2 d-block d-md-inline btn btn-outline-primary" style="margin-left:5px">
            <i class="fas fa-times"></i> Cancelar
          </button>
        </router-link>
        <button v-if="form.status.value == 'd' || form.status.value == null" role="button"
          class="mb-2 bl-2 d-block d-md-inline btn btn-primary" style="margin-left:5px" @click="storeDraft('draft')">
          <i class="fas fa-edit"></i> Rascunho NF-e
        </button>
        <button v-if="form.status.value != 'o' && form.status.value != 'c'" role="button"
          class="mb-2 bl-2 d-block d-md-inline btn btn-success" style="margin-left:5px"
          @click="storeInvoice('invoice')">
          <i class="fas fa-check"></i> Emitir NF-e
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "./../../mixins/Form.js";
import Filters from "./../../mixins/Filters.js";
import OrderProducts from "../../components/sections/OrderProducts";
import OrderPayments from "../../components/sections/OrderPayments";
import PersonCard from "./../../components/sections/PersonCard";
import ClientSearch from "./../../components/ClientSearch";
import SalesmanSearch from "./../../components/SalesmanSearch";
import ClientStats from "./../../components/sections/person/ClientStats";
import VueRouter from "./../../router";
import NfeShipping from "./../../components/sections/NfeShipping";
import NfeProductGrid from "./../../components/lists/NfeProductGrid";
import NfeObservations from "./../../components/sections/NfeObservations";
import NfeSearch from "../../components/NfeSearch";
import VendorSearch from "./../../components/VendorSearch.vue";
import InvoiceTotals from "@/components/invoice/sections/InvoiceTotals";

export default {
  components: {
    OrderProducts,
    OrderPayments,
    PersonCard,
    ClientSearch,
    SalesmanSearch,
    ClientStats,
    NfeShipping,
    NfeProductGrid,
    NfeObservations,
    NfeSearch,
    VendorSearch,
    InvoiceTotals,
  },

  data: function () {
    return {
      showChave: false,

      finalidade_nfe_options: [
        { value: 1, text: "NF-e Venda" },
        { value: 2, text: "NF-e Complementar" },
        { value: 3, text: "NF-e de Ajuste" },
        { value: 4, text: "Devolução de mercadoria" },
      ],

      operation_options: [
        { value: 0, text: "Entrada de Mercadoria" },
        { value: 1, text: "Saída de Mercadoria" },
      ],

      form: new Form({
        unidentified_client: {
          default: 0
        },

        operation: {
          value: null
        },

        finalidade_nfe: {
          value: null
        },

        type_nfe: {
          value: null
        },

        chave_nfe_referenciada: {
          value: null
        },
        autXml_cnpj: {
          value: null
        },

        dhSaiEnt: {
          value: null
        },

        model: {
          value: null
        },

        number: {
          value: null
        },

        serie: {
          options: null
        },

        presence_indicator: {
          value: 1
        },

        client_id: {
          alias: "Cliente",
          validate: null,
          value: null
        },

        name: {},

        salesman_id: {},

        salesman_name: {},

        addition: {
          value: 0
        },

        discount: {
          value: 0
        },

        shipping: {
          value: 0
        },

        status: {},

        //transport
        type_shipping: {
          value: 0
        },

        mod_frete: {
          value: 9,
          options: {
            0: "Contratação do Frete por conta do Remetente(CIF)",
            1: "Contratação do Frete por conta do Destinatário(FOB)",
            2: "Contratação do Frete por conta de Terceiros",
            3: "Transporte Próprio por conta do Remetente",
            4: "Transporte Próprio por conta do Destinatário",
            9: "Sem Ocorrência de Transporte"
          }
        },

        shipping_value: {},

        transportadora_id: {},

        vehicle_plate: {},

        vehicle_uf: {
          options: {
            AC: "Acre",
            AL: "Alagoas",
            AM: "Amazonas",
            AP: "Amapá",
            BA: "Bahia",
            CE: "Ceará",
            DF: "Distrito Federal",
            ES: "Espírito Santo",
            GO: "Goiás",
            MA: "Maranhão",
            MT: "Mato Grosso",
            MS: "Mato Grosso do Sul",
            MG: "Minas Gerais",
            PA: "Pará",
            PB: "Paraíba",
            PR: "Paraná",
            PE: "Pernambuco",
            PI: "Piauí",
            RJ: "Rio de Janeiro",
            RN: "Rio Grande do Norte",
            RS: "Rio Grande do Sul",
            RO: "Rondônia",
            RR: "Roraima",
            SC: "Santa Catarina",
            SP: "São Paulo",
            SE: "Sergipe",
            TO: "Tocantins"
          }
        },

        RNTC: {},

        indentidica_volume: {},

        quantity_volume: {},

        type_volume: {},

        peso_bruto: {},

        peso_liquido: {},
        //end transport

        informacao_complementar: {
          value: null
        },

        informacao_fisco: {
          value: null
        }
      }),
      title: {},

      products: [],

      payments: [],

      additionPercent: 0,

      discountPercent: 0,

      shippingPercent: 0,

      error: null,

      unidentified_client_options: [{
        value: 1,
        text: "Consumidor Final"
      },
      {
        value: 0,
        text: "Informar Cliente"
      }
      ],

      save_mode: null,

      selectedPerson: null,

      alertData: {
        isVisible: false,
        message: null
      },

      nfeStatus: {
        draft: {
          url: "api/nfe/store",
          msg: "Salvo como Rascunho!"
        },

        invoice: {
          url: "api/nfe/store",
          msg: "Nota Fiscal Salva com sucesso"
        }
      }
    };
  },

  mounted() { },

  created() {
    this.setState();

    if (this.$route.params.id) {
      axios
        .post("../../api/nfe/edit/" + this.$route.params.id)
        .then(response => {
          this.form.setValues(response.data.nfe);

          this.products = response.data.nfe_products;

          this.payments = response.data.nfe_payments;

          this.form.serie.options = response.data.nfe.serie;

          this.calcUpdatePercent("addition");
          this.calcUpdatePercent("discount");
          this.calcUpdatePercent("shipping");

          this.showChave = this.hasReference
          this.$store.commit("pageHasLoaded");
        })
        .catch(error => {
          this.error = error;
        });
    } else {
      this.$store.commit("pageHasLoaded");
    }
  },

  computed: {
    unidentifiedClient() {
      return this.form.unidentified_client.value;
    },

    url() {
      var url = process.env.BASE_URL + "api/nfe/store";

      if (this.$route.params.id) {
        url = url + "/" + this.$route.params.id;
      }

      return url;
    },

    hasProducts() {
      return this.products.length > 0;
    },

    productsTotal() {
      var sum = 0;

      for (let index in this.products) {
        sum += this.products[index].quantity * this.products[index].price;
      }

      return Math.round(sum * 100) / 100;
    },

    orderTotal() {
      return (
        Math.round(
          (this.productsTotal +
            this.form.addition.value -
            this.form.discount.value +
            this.form.shipping.value) *
          100
        ) / 100
      );
    },

    isSingle() {
      return this.$route.params.state == "nfe_avulsa";
    },
    isDevolucaoCompraMercadoria() {
      return this.$route.params.state == "devolucao_nfe_compra"
    },
    isDevolution() {
      return this.form.finalidade_nfe.value == 4;
    },
    showSwitchNfeReference() {
      return this.form.model.value == 55 && !this.isDevolution;
    },
    hasReference() {
      return this.form.chave_nfe_referenciada.value
    },
    showChaveNfeReferenciada: {
      get() {
        return this.hasReference && this.showSwitchNfeReference;
      },
      set(value) {
        this.showChave = value
      }
    }
  },

  watch: {
    products() {
      this.calcUpdateValue("addition");
      this.calcUpdateValue("discount");
      this.calcUpdateValue("shipping");
    },

    unidentifiedClient(newValue) {
      if (newValue == 0) {
        this.form.client_id.validate = {
          required: true
        };
      } else {
        this.form.client_id.value = null;
        this.form.client_id.validate = null;
      }
    }
  },

  methods: {
    selectSerie() {
      axios
        .post(
          "./../../../api/nfe/selectserieandnumbernfe/" + this.form.model.value
        )
        .then(response => {
          this.form.serie.options = this.getSerieOptions(response.data);

          this.form.serie.value = response.data.series.serie;

          if (response.data.numberNf == null) {
            this.form.number.value = 1;
          } else {
            this.form.number.value = response.data.numberNf;
          }

          this.$store.commit("pageHasLoaded");
        })
        .catch(error => {
          this.error = error;
        });
    },

    getSerieOptions(data) {
      var options = {};

      for (let index in data) {
        options[data[index].id] = data[index].serie;
      }

      return options;
    },

    getUrl(status) {
      var url = process.env.BASE_URL + this.nfeStatus[status].url;

      if (this.$route.params.id) {
        url = url + "/" + this.$route.params.id;
      }

      return url;
    },

    storeDraft(nfeStatus) {
      this.save_mode = "draft";

      if (this.form.isValid()) {
        this.$store.commit("showLoading");

        axios
          .post(this.getUrl(nfeStatus), this.getAttributes())
          .then(response => {
            this.$store.commit("hideLoading");

            VueRouter.push({
              path: "/nf-e"
            });

            this.$store.commit("showAlert", {
              message: this.nfeStatus[nfeStatus].msg,
              type: "success"
            });
          })
          .catch(error => {
            this.$store.commit("hideLoading");
            this.error = error;
          });
      } else {
        this.alertData.message = this.form.getFirstErrorMsg();

        this.alertData.isVisible = true;
      }
    },

    storeInvoice(nfeStatus) {

      this.save_mode = "invoice";

      if (this.form.isValid()) {
        this.$store.commit("showLoading");

        axios
          .post(this.getUrl(nfeStatus), this.getAttributes())
          .then(response => {
            this.$store.commit("hideLoading");

            VueRouter.push({
              path: "/nf-e"
            });

            this.$store.commit("showAlert", {
              message: this.nfeStatus[nfeStatus].msg,
              type: "success"
            });
          })
          .catch(error => {
            this.$store.commit("hideLoading");
            this.error = error;
          });
      } else {
        this.alertData.message = this.form.getFirstErrorMsg();

        this.alertData.isVisible = true;
      }
    },

    // prepare the attributes for store
    getAttributes() {
      var attributes = this.form.getValues();

      attributes.save_mode = this.save_mode;

      attributes.products = this.products;

      attributes.payments = this.payments;

      return attributes;
    },

    // remove product from list
    deleteProduct(index) {
      // prevent discount error
      this.form.discount.value = 0;
      this.discountPercent = 0;

      this.$delete(this.products, index);
    },

    // set update state on orderProduct component
    setProductUpdate(index) {
      this.$refs.orderProducts.setProductUpdate(index);
    },

    // calcs the value or totals when change percent
    calcUpdateValue(field) {
      this.form[field].value =
        Math.round(this.productsTotal * (this[field + "Percent"] / 100) * 100) /
        100;
    },

    // calcs the percent or totals when change value
    calcUpdatePercent(field) {
      if (this.productsTotal != 0) {
        this[field + "Percent"] =
          (this.form[field].value * 100) / this.productsTotal;
        return;
      }
    },

    setState() {
      if (this.$route.params.state == "venda_nfe") {
        this.form.operation.value = "Venda de Mercadorias";
        this.form.finalidade_nfe.value = 1;
        this.form.type_nfe.value = 1;
        this.form.model.value = 55;
        this.title = 'NF-e de Venda'
        this.selectSerie();
      }

      if (this.$route.params.state == "devolucao_nfe_compra") {
        this.form.operation.value = "Devolução de compras";
        this.form.finalidade_nfe.value = 4;
        this.form.type_nfe.value = 1;
        this.form.model.value = 55;
        this.title = 'NF-e de devolução de compras'
        this.selectSerie();
      }

      if (this.$route.params.state == "devolucao_nfe") {
        this.form.operation.value = "Devolução de Venda";
        this.form.finalidade_nfe.value = 4;
        this.form.type_nfe.value = 0;
        this.form.model.value = 55;
        this.title = 'NF-e de Devolução de Venda'
        this.selectSerie();
      }

      if (this.$route.params.state == "venda_nfce") {
        this.form.operation.value = "Venda de Mercadorias";
        this.form.finalidade_nfe.value = 1;
        this.form.type_nfe.value = 1;
        this.form.model.value = 65;
        this.title = 'NFC-e de Venda'
        this.selectSerie();
      }

      if (this.$route.params.state == "devolucao_nfce") {
        this.form.operation.value = "Devolução de Venda";
        this.form.finalidade_nfe.value = 4;
        this.form.type_nfe.value = 0;
        this.form.model.value = 55;
        this.title = 'NFC-e de Devolução de Venda'
        this.selectSerie();
      }

      if (this.$route.params.state == "nfe_avulsa") {
        this.form.operation.value = null;
        this.form.finalidade_nfe.value = null;
        this.form.type_nfe.value = null;
        this.form.model.value = 55;
        this.title = "NF-e Avulsa";
        this.selectSerie();
      }
    },

  },
};
</script>

<style>
.row-list-product {
  padding-top: 1rem;
  padding-bottom: 1rem;
  /*border-top: dashed 1px gray;*/
  border-bottom: dashed 1px rgba(0, 0, 0, 0.125);
}

.row-list-first {
  padding-top: 1rem;
  /*border-top: dashed 1px rgba(0, 0, 0, 0.125);*/
  border-top: dashed 1px rgba(0, 0, 0, 0.125);
}
</style>
